import { render, staticRenderFns } from "./KitchenSink.vue?vue&type=template&id=4adf6352"
import script from "./KitchenSink.vue?vue&type=script&lang=js"
export * from "./KitchenSink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports